import type { CreateTournamentDto, TournamentTemplateDto } from '@pokerroom/types';

export function applyTournamentTemplateDefaults(
  template: TournamentTemplateDto,
): CreateTournamentDto {
  return {
    templateId: template.id,
    ...(template.timedFeeVersion ? { timedFeeVersionId: template.timedFeeVersion.id } : {}),
    name: template.name,
    type: template.type,
    payoutType: template.payoutType,
    buyin: template.buyinAmount ?? '1000',
    startingChips: template.startingChips,
    lateRegLevels: template.lateRegLevels,
    blindStructureId: template.blindStructureId ?? '',
    rebuyAllowed: template.rebuyAllowed,
    rebuyDeadline: template.rebuyDeadline,
    rebuyCost: template.rebuyCost,
    rebuyChips: template.rebuyChips,
    maxRebuy: template.maxRebuy,
    addonAllowed: template.addonAllowed,
    addonDeadline: template.addonDeadline,
    addonCost: template.addonCost,
    addonChips: template.addonChips,
    maxAddon: template.maxAddon,
    manualCountMode: template.manualCountMode,
    gtdPrizePool: template.gtdPrizePool,
    bountyAmount: template.bountyAmount,
    rakePct: template.rakePct,
    displaySideInfo: template.displaySideInfo ?? [],
    displayMarquee: template.displayMarquee ?? '',
  };
}

interface NameInput {
  value: string;
  focus(): void;
  setSelectionRange(start: number, end: number): void;
}

export function focusTournamentNameSuffix(input: NameInput): void {
  input.focus();
  input.setSelectionRange(input.value.length, input.value.length);
}
